import type { CanvasI } from "tweenly"
import { selectCanvasResolution } from "../helpers/selector.helpers"
import { addCanvasAction } from "../store/slices/canvas.slice"
import { useAppDispatch, useAppSelector } from "./useRedux"

export const useCanvas = () => {
    const dispatch = useAppDispatch()
    const addCanvas = (canvas: CanvasI) => dispatch(addCanvasAction({ canvas }))
    // one memoized selector instead of two subscriptions plus a local useMemo — the result is
    // referentially stable across unrelated actions
    const canvasResolution = useAppSelector(selectCanvasResolution)

    return {
        addCanvas,
        canvasResolution,
    }
}
